import Vue from 'vue';
import Router from 'vue-router';
import http, { getToken, saveAuth } from '../api';
import { operatorHomePath, hasPermKey } from '../views/admin/permissions.js';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login',         component: () => import('../views/Login.vue') },
    { path: '/admin/login',   component: () => import('../views/Login.vue') },
    { path: '/ops/login',     component: () => import('../views/Login.vue') },
    { path: '/change-password', component: () => import('../views/ChangePassword.vue'), meta: { role: 'channel' } },

    // 渠道后台
    {
      path: '/',
      component: () => import('../views/channel/Layout.vue'),
      meta: { role: 'channel' },
      children: [
        { path: '', redirect: '/home' },
        { path: 'home', component: () => import('../views/channel/Home.vue') },
        { path: 'deposit/list', component: () => import('../views/channel/DepositList.vue') },
        { path: 'expense/new', component: () => import('../views/channel/ExpenseNew.vue') },
        { path: 'expense/list', component: () => import('../views/channel/ExpenseList.vue') },
        { path: 'expense/:id(\\d+)', component: () => import('../views/channel/ExpenseDetail.vue') },
        { path: 'invoice/summary', component: () => import('../views/channel/InvoiceSummary.vue') },
        { path: 'invoice/submit', component: () => import('../views/channel/InvoiceSubmit.vue') },
        { path: 'invoice/ledger', component: () => import('../views/channel/InvoiceLedger.vue') },
        { path: 'invoice/list', component: () => import('../views/channel/InvoiceList.vue') },
        { path: 'invoice/detail', component: () => import('../views/channel/InvoiceDetail.vue') },
        { path: 'subsidies', component: () => import('../views/channel/SubsidyList.vue') },
        { path: 'qr', component: () => import('../views/channel/QrEntry.vue') },
        { path: 'profile', component: () => import('../views/channel/Profile.vue') }
      ]
    },

    // 扫码入口
    { path: '/scan/:token', component: () => import('../views/scan/ScanEntry.vue') },

    // 管理员/运营后台
    {
      path: '/admin',
      component: () => import('../views/admin/Layout.vue'),
      meta: { role: 'admin' },
      children: [
        { path: '', redirect: () => {
            const a = getToken();
            if (a && a.role === 'ops') return '/admin/expenses';
            // operator: 按权限挑落地页 (财务账号 → 发票核销工作台)
            if (a && a.role === 'operator') return operatorHomePath(a.permissions) || '/login';
            // 渠道账号走渠道后台 (否则会落进 admin 布局再被守卫弹回, 形成重定向循环)
            if (a && a.role === 'channel') return '/home';
            return '/admin/dashboard';
          }
        },
        // 每条路由都声明所需权限位 (perm):
        //   运营账户没有该权限时, 守卫直接弹回自己的落地页,
        //   避免"页面渲染出来 → 接口 403 → 白屏 + 控制台一堆 403"的错误状态。
        { path: 'dashboard',            component: () => import('../views/admin/Dashboard.vue'),         meta: { roles: ['admin', 'operator'], perm: 'admin.analytics.read' } },
        { path: 'channels',             component: () => import('../views/admin/Channels.vue'),          meta: { roles: ['admin', 'operator'], perm: 'admin.channels.read' } },
        { path: 'ops-users',            component: () => import('../views/admin/OpsUsers.vue'),          meta: { roles: ['admin'] } },
        { path: 'deposits',             component: () => import('../views/admin/DepositReview.vue'),     meta: { roles: ['admin', 'operator'], perm: 'admin.deposits.read' } },
        { path: 'invoices',             component: () => import('../views/admin/InvoiceReceive.vue'),    meta: { roles: ['admin', 'operator'], perm: 'admin.invoices.read' } },
        { path: 'invoices/:id(\\d+)',   component: () => import('../views/admin/InvoiceAccept.vue'),      meta: { roles: ['admin', 'operator'], perm: 'admin.invoices.read' } },
        { path: 'invoice-verify',         component: () => import('../views/admin/InvoiceVerifyList.vue'),  meta: { roles: ['admin', 'operator'], perm: 'fin.invoice.verify' } },
        { path: 'invoice-archive',        component: () => import('../views/admin/InvoiceArchive.vue'),      meta: { roles: ['admin', 'operator'], perm: 'admin.invoice.archive.read' } },
        { path: 'invoice-verify/:id(\\d+)',component: () => import('../views/admin/InvoiceVerifyDetail.vue'),meta: { roles: ['admin', 'operator'], perm: 'fin.invoice.verify' } },
        { path: 'invoice-verify-stats',     component: () => import('../views/admin/InvoiceVerifyStats.vue'),    meta: { roles: ['admin', 'operator'], perm: 'fin.invoice.verify' } },
        { path: 'invoice-verify-channel/:id(\\d+)', component: () => import('../views/admin/InvoiceVerifyChannel.vue'), meta: { roles: ['admin', 'operator'], perm: 'fin.invoice.verify' } },
        { path: 'invoice-details',      component: () => import('../views/admin/InvoiceDetailList.vue'), meta: { roles: ['admin', 'operator'], perm: 'admin.invoices.read' } },
        { path: 'invoice-detail-new',   component: () => import('../views/admin/InvoiceDetailCreate.vue'), meta: { roles: ['admin', 'operator'], perm: 'admin.invoices.write' } },
        { path: 'channel-invoice-list', component: () => import('../views/admin/ChannelInvoiceList.vue'), meta: { roles: ['admin', 'operator'], perm: 'admin.channels.read' } },
        { path: 'channel-invoice-detail', component: () => import('../views/admin/ChannelInvoiceDetail.vue'), meta: { roles: ['admin', 'operator'], perm: 'admin.channels.read' } },
        { path: 'subsidies',            component: () => import('../views/admin/SubsidyGrant.vue'),       meta: { roles: ['admin', 'operator'], perm: 'admin.subsidies.read' } },
        { path: 'logs',                 component: () => import('../views/admin/Logs.vue'),              meta: { roles: ['admin', 'operator'], perm: 'admin.logs.read' } },
        { path: 'reports',              component: () => import('../views/admin/Reports.vue'),           meta: { roles: ['admin', 'operator'], perm: 'admin.reports.read' } },
        { path: 'drivers',              component: () => import('../views/admin/Drivers.vue'),           meta: { roles: ['admin', 'operator'], perm: 'admin.drivers.read' } },
        { path: 'analytics',            component: () => import('../views/admin/Analytics.vue'),         meta: { roles: ['admin', 'operator'], perm: 'admin.analytics.read' } },
        { path: 'analytics/company/:id(\\d+)', component: () => import('../views/admin/CompanyDetail.vue'), meta: { roles: ['admin', 'operator'], perm: 'admin.analytics.read' } },
        { path: 'expenses',             component: () => import('../views/admin/ExpenseReview.vue'),     meta: { roles: ['admin', 'ops', 'operator'], perm: 'admin.expenses.read' } }
      ]
    },

    { path: '/', redirect: '/login' },
    { path: '*', redirect: '/login' }
  ]
});

router.beforeEach(async (to, from, next) => {
  const auth = getToken();
  if (to.meta.role) {
    if (to.meta.role === 'channel') {
      if (!auth || auth.role !== 'channel') return next('/login');
    } else if (to.meta.role === 'admin') {
      if (!auth) return next('/login');
    }
  }
  if (to.meta.roles && Array.isArray(to.meta.roles)) {
    if (!auth || !to.meta.roles.includes(auth.role)) {
      if (auth && auth.role === 'admin') return next('/admin/dashboard');
      if (auth && auth.role === 'ops')   return next('/admin/expenses');
      if (auth && auth.role === 'operator') {
        return next(operatorHomePath(auth.permissions) || '/login');
      }
      if (auth && auth.role === 'channel') return next('/');
      return next('/login');
    }
    // 路由级权限位: operator 需持有指定权限才能进入
    //   (如 发票核销 → fin.invoice.verify, 发票存档 → admin.invoice.archive.read)
    //   没有该权限时直接弹回自己的落地页, 不要先把页面渲染出来再让接口 403。
    if (to.meta.perm && auth && auth.role === 'operator') {
      // 取实时权限 (服务端 DB 为准): 管理员刚授权时, 本地 token 快照还是旧的
      let perms = Array.isArray(auth.permissions) ? auth.permissions : [];
      try {
        const r = await http.get('/admin/me/permissions');
        if (r && Array.isArray(r.permissions)) {
          perms = r.permissions;
          const a = getToken();
          if (a) saveAuth(Object.assign({}, a, { permissions: r.permissions }));
        }
      } catch (e) { /* 取不到则退回本地快照 */ }
      if (!hasPermKey(perms, to.meta.perm)) {
        // 无权进入: 跳到该账号有权限的落地页
        //   注意: 落地页可能就是当前页 (如无核销权限却访问核销页), 需避开以免死循环
        const home = operatorHomePath(perms);
        if (!home || home === to.path) return next('/login');
        return next(home);
      }
    }
  }
  if (auth && auth.role === 'channel' && auth.must_change_pwd && to.path !== '/change-password') {
    return next('/change-password');
  }
  next();
});

export default router;